import {createApp} from "vue";

import 'vuetify/styles'
import {createVuetify} from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import * as labsComponents from 'vuetify/labs/components'

import {fa} from "vuetify/iconsets/fa";
import {aliases, mdi} from "vuetify/lib/iconsets/mdi";
// make sure to also import the coresponding css
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader
import "@fortawesome/fontawesome-free/css/all.css"; // Ensure your project is capable of handling css files

import {cs} from "vuetify/locale";

import App from "./App.vue";
import router from "./router.js";
import "./axios";

import {createPinia} from "pinia";
import piniaPersist from 'pinia-plugin-persistedstate'

//import VueGtag from "vue-gtag";
import colors from 'vuetify/util/colors'

import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

const app = createApp(App);

const THEME_KEY = 'xfm-theme';
const MIGRATION_FLAG = 'theme_reset_done_v1';

if (!localStorage.getItem(MIGRATION_FLAG)) {
  const savedTheme = localStorage.getItem(THEME_KEY);

  if (!savedTheme || savedTheme === 'dark') {
    localStorage.setItem(THEME_KEY, 'light');
  }

  localStorage.setItem(MIGRATION_FLAG, '1');
}

const vuetify = createVuetify({
    locale: {
        locale: 'cs',
        fallback: 'cs',
        messages: {cs},
        rtl: {cs: false},
    },
    date: {
        locale: {
            en: 'cs',
        },
    },
    theme: {
        defaultTheme: "light",
        themes: {
            light: {
                dark: false,
                colors: {
                    users: colors.blue.darken2,
                    addresses: colors.teal.darken2,
                    resources: colors.lime.darken2,
                    products: colors.lightGreen.darken2,
                    categories: colors.orange.darken2,
                    orders: colors.amber.darken2,
                    notes: colors.blueGrey.darken2,
                }
            },
            dark: {
                light: false,
                colors: {
                    users: colors.blue.accent2,
                    addresses: colors.teal.accent2,
                    resources: colors.lime.accent2,
                    products: colors.lightGreen.accent2,
                    categories: colors.orange.accent2,
                    orders: colors.amber.accent2,
                    notes: colors.blueGrey.darken2,
                }
            },
        },
    },
    defaults: {
        VCard: {
            rounded: 'xl',
        },
        VField: {
            rounded: 'xl',
        },
        VCol: {
            VBtn: {
                color: 'surface-light',
                variant: 'flat',
                ripple: true,
                class: ['mx-2'],
            }
        },
    },
    icons: {
        defaultSet: "mdi",
        aliases,
        sets: {
            mdi,
            fa,
        },
    },
    components,
    directives,
    labsComponents,
})

const pinia = createPinia();
pinia.use(piniaPersist)

app.use(vuetify);

app.use(router);
//app.use(VueGtag, { config: { id: "XXX" } }); // for google analytics
app.use(pinia);

app.use(Toast, {
  toastClassName: 'custom-toast',
  bodyClassName: 'custom-toast-body',
  position: 'top-center',
  timeout: 4000
})

app.mount("#app");
